import moment from "moment";
import { get } from "lodash"; // import axios from "axios";

import { DF_RECEIVE_CREATE_SESSION, DF_RECEIVE_INIT_CHASITOR, DF_REQUEST_CREATE_SESSION, DF_REQUEST_INIT_CHASITOR, DF_REQUEST_CLIENT_END_CHAT, DF_RECEIVE_CLIENT_END_CHAT, DF_RECEIVE_MESSAGES, SET_SEQUENCE, DF_RECEIVE_CHAT, DF_TIMED_QUEUE_JOIN_MESSAGE, DF_RESET_QUEUE_JOIN_MESSAGE, REQUEST_CHAT_AN_ADVISOR, RECEIVE_CHAT_AN_ADVISOR, GO_TO_ERROR_SCREEN, DF_CHASITOR_NOT_TYPING, DF_CHASITOR_TYPING, DF_CHAT_MESSAGE, DF_CREATE_LIVE_AGENT_SESSION, DF_INIT_CHASITOR, DF_MESSAGES, DF_CHAT_END, INITIATE_ADVISOR_CHAT, CHAT_PROXY } from "./Constants";
import { MESSAGE_TYPE, CHAT_STATUS } from "../constants";
import retry from "../utils/retry";
import { cyclePositionMessage, setChatStatus } from "./ChatActions";

function requestCreateSession() {
  return {
    type: DF_REQUEST_CREATE_SESSION
  };
}

function receiveCreateSession(result) {
  return {
    type: DF_RECEIVE_CREATE_SESSION,
    result
  };
}

export function fetchCreateSession(apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestCreateSession());
    let result = {};

    try {
      result = await apiClient.post(`${CHAT_PROXY}?url=${DF_CREATE_LIVE_AGENT_SESSION}`, null, null, {
        method: "GET",
        headers: {
          "X-LIVEAGENT-AFFINITY": "null",
          "X-LIVEAGENT-API-VERSION": apiClient.chatConfig.liveagent.apiVersion
        }
      });
    } catch (e) {
      throw new Error();
    }

    dispatch(receiveCreateSession(result));
  };
}

function requestInitChasitor() {
  return {
    type: DF_REQUEST_INIT_CHASITOR
  };
}

function receiveInitChasitor() {
  return {
    type: DF_RECEIVE_INIT_CHASITOR
  };
}

export function fetchInitChasitor(apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestInitChasitor());
    const chatConfiguration = getState().chat;
    const sessionKey = chatConfiguration.chatBot.dfKey;
    const affinity = chatConfiguration.chatBot.dfAffinity;
    const caseId = chatConfiguration.chatBot.dfCaseId || chatConfiguration.config.caseId;
    const sessionDetails = chatConfiguration.chatBot.session ? [{
      label: "Session Key",
      value: chatConfiguration.chatBot.session,
      entityMaps: [],
      transcriptFields: [],
      displayToAgent: false
    }, {
      label: "Session Id",
      value: chatConfiguration.chatBot.session,
      entityMaps: [],
      transcriptFields: [],
      displayToAgent: false
    }] : [];
    const prechatDetails = [{
      displayToAgent: true,
      entityMaps: [],
      label: "Parcel Code",
      transcriptFields: [],
      value: chatConfiguration.config.parcelCode
    }, {
      displayToAgent: true,
      entityMaps: [{
        entityName: "Case",
        fieldName: "Id"
      }],
      label: "CaseId",
      transcriptFields: ["CaseId"],
      value: caseId
    }, {
      label: "Chatbot",
      value: true,
      entityMaps: [],
      transcriptFields: [],
      displayToAgent: true
    }, {
      label: "Reason",
      value: apiClient.chatConfig.additionalDetails.reason || "",
      entityMaps: [],
      transcriptFields: [],
      displayToAgent: true
    }, {
      label: "Platform",
      value: apiClient.chatConfig.additionalDetails.platform,
      entityMaps: [],
      transcriptFields: [],
      displayToAgent: true
    }, ...sessionDetails];
    const prechatEntities = [{
      entityName: "Case",
      saveToTranscript: "CaseId",
      showOnCreate: false,
      linkToEntityName: "Case",
      linkToEntityField: "CaseId",
      entityFieldsMaps: [{
        fieldName: "id",
        label: "CaseId",
        doFind: true,
        isExactMatch: true,
        doCreate: false
      }]
    }];
    const {
      platinumDeploymentId,
      eliteDeploymentId,
      organizationId,
      platinumButtonId,
      eliteButtonId
    } = apiClient.chatConfig.liveagent;
    const accountQueue = chatConfiguration.config.queueType;
    const body = {
      organizationId,
      deploymentId: accountQueue === "Platinum" ? platinumDeploymentId : eliteDeploymentId,
      buttonId: accountQueue === "Platinum" ? platinumButtonId : eliteButtonId,
      sessionId: chatConfiguration.chatBot.dfId,
      userAgent: "DPDChatbot",
      language: "en-GB",
      screenResolution: "1920x1080",
      visitorName: "",
      prechatDetails,
      prechatEntities,
      receiveQueueUpdates: true,
      isPost: true
    };

    try {
      await retry(async () => {
        await apiClient.post(`${CHAT_PROXY}?url=${DF_INIT_CHASITOR}`, null, null, {
          method: "POST",
          headers: {
            "X-LIVEAGENT-AFFINITY": affinity,
            "X-LIVEAGENT-SESSION-KEY": sessionKey,
            "X-LIVEAGENT-SEQUENCE": chatConfiguration.chatBot.dfSequence || 1,
            "X-LIVEAGENT-API-VERSION": apiClient.chatConfig.liveagent.apiVersion
          },
          body
        });
      }, 5);
    } catch (e) {
      throw new Error();
    }

    dispatch(receiveInitChasitor());
  };
}
export function updateChasitorTyping(apiClient, isTyping) {
  return async (dispatch, getState) => {
    const {
      dfKey,
      dfAffinity,
      dfSequence,
      dfCaseId,
      dfId
    } = getState().chat.chatBot;
    if (!dfCaseId && !dfId) return;
    const url = isTyping ? DF_CHASITOR_TYPING : DF_CHASITOR_NOT_TYPING;
    const sequence = dfSequence || 1;

    try {
      await apiClient.post(`${CHAT_PROXY}?url=${url}`, null, null, {
        method: "POST",
        headers: {
          "X-LIVEAGENT-AFFINITY": dfAffinity,
          "X-LIVEAGENT-SESSION-KEY": dfKey,
          "X-LIVEAGENT-SEQUENCE": sequence,
          "X-LIVEAGENT-API-VERSION": apiClient.chatConfig.liveagent.apiVersion
        },
        body: {}
      });
      dispatch(setSequence(sequence + 1));
    } catch (e) {
      throw new Error(e);
    }
  };
}

function setSequence(sequence) {
  return {
    type: SET_SEQUENCE,
    sequence
  };
}

function receiveMessages(messages) {
  return {
    type: DF_RECEIVE_MESSAGES,
    messages
  };
}

function getAdvisorMessage({
  chatId,
  ack,
  local,
  apiClient
}) {
  return async (dispatch, getState) => {
    dispatch(cyclePositionMessage());
    const {
      dfKey,
      dfAffinity,
      dfId
    } = getState().chat.chatBot; // break loop if chat ID changed

    if (chatId !== dfId) {
      return;
    }

    let result = null;
    const url = DF_MESSAGES + "?ack=" + ack;

    try {
      await retry(async () => {
        result = await apiClient.post(`${CHAT_PROXY}?url=${url}`, null, null, {
          method: "GET",
          headers: {
            "X-LIVEAGENT-AFFINITY": dfAffinity,
            "X-LIVEAGENT-SESSION-KEY": dfKey,
            "X-LIVEAGENT-API-VERSION": apiClient.chatConfig.liveagent.apiVersion
          }
        });
      }, 5);
    } catch (e) {
      throw new Error(e);
    }

    if (result?.messages) {
      dispatch(receiveMessages(result.messages));
    }

    let newAck = ack + 1;

    if (result?.sequence) {
      newAck = result.sequence;
    }

    const messageType = get(result, "messages[0].type", "");

    if (messageType !== MESSAGE_TYPE.CHAT_ENDED && messageType !== MESSAGE_TYPE.CHAT_REQUEST_FAIL) {
      dispatch(getAdvisorMessage({
        chatId,
        ack: newAck,
        local,
        apiClient
      }));
    }
  };
}

function receiveChatMessage() {
  return {
    type: DF_RECEIVE_CHAT
  };
}

export function sendVisitorMessage(message, apiClient) {
  return async (dispatch, getState) => {
    if (message.trim() === "") {
      return;
    }

    const {
      dfKey,
      dfSequence,
      dfAffinity
    } = getState().chat.chatBot;
    await retry(async () => {
      await apiClient.post(`${CHAT_PROXY}?url=${DF_CHAT_MESSAGE}`, null, null, {
        method: "POST",
        headers: {
          "X-LIVEAGENT-AFFINITY": dfAffinity,
          "X-LIVEAGENT-SESSION-KEY": dfKey,
          "X-LIVEAGENT-SEQUENCE": dfSequence || 1,
          "X-LIVEAGENT-API-VERSION": apiClient.chatConfig.liveagent.apiVersion
        },
        body: {
          text: message
        }
      });
    });
    dispatch(receiveChatMessage());
  };
}

function requestChatEnd() {
  return {
    type: DF_REQUEST_CLIENT_END_CHAT
  };
}

function receiveChatEnd() {
  return {
    type: DF_RECEIVE_CLIENT_END_CHAT
  };
}

function resetQueueJoinMessage() {
  return {
    type: DF_RESET_QUEUE_JOIN_MESSAGE
  };
}

function timedQueueJoinMessage() {
  return {
    type: DF_TIMED_QUEUE_JOIN_MESSAGE
  };
}

export function fetchChatEnd(apiClient) {
  return async (dispatch, getState) => {
    const state = getState().chat;

    if (state.chatBot.state === CHAT_STATUS.CALL_CENTER_CLOSED) {
      return;
    }

    dispatch(requestChatEnd());
    const {
      dfKey,
      dfAffinity
    } = getState().chat.chatBot;
    await apiClient.post(`${CHAT_PROXY}?url=${DF_CHAT_END}`, null, null, {
      method: "POST",
      headers: {
        "X-LIVEAGENT-AFFINITY": dfAffinity,
        "X-LIVEAGENT-SESSION-KEY": dfKey,
        "X-LIVEAGENT-SEQUENCE": state.chatBot.dfSequence || 1,
        "X-LIVEAGENT-API-VERSION": apiClient.chatConfig.liveagent.apiVersion
      },
      body: {
        reason: "client"
      }
    });
    dispatch(receiveChatEnd());
  };
}

function requestChatAnAdvisor() {
  return {
    type: REQUEST_CHAT_AN_ADVISOR
  };
}

function goToErrorScreen() {
  return {
    type: GO_TO_ERROR_SCREEN
  };
}

function receiveChatAnAdvisor(caseId, id, message, agentUrl) {
  return {
    type: RECEIVE_CHAT_AN_ADVISOR,
    caseId,
    id,
    message,
    agentUrl
  };
}

export function initiateAdvisorChat(apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestChatAnAdvisor());
    const chatConfiguration = getState().chat;
    const totalMessages = chatConfiguration.chatBot.previousMessages.concat(chatConfiguration.chatBot.messageHistory);
    const chatTranscript = totalMessages.map(messages => {
      const role = messages.source === "dpd" ? "Bot" : "User";
      const date = messages.timestamp ? messages.timestamp.format("DD/MM/YYYY, HH:mm:ss") : moment.format("DD/MM/YYYY, HH:mm:ss");

      if (messages.messages && messages.messages.length > 0) {
        return messages.messages.map(message => "[[[" + date + "]]] " + role + ": " + message).join(" ");
      }

      return "";
    }).join(" ");
    let result = {};

    try {
      result = await apiClient.post(INITIATE_ADVISOR_CHAT, null, null, {
        parcelCode: chatConfiguration.config.parcelCode,
        chatTranscript
      });
    } catch (e) {
      dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
      throw new Error(e);
    }

    dispatch(receiveChatAnAdvisor(result.caseCode, result.id, result.message, result.liveAgentUrl));
  };
}
export function checkIfAdvisorIsAvailable() {
  return (dispatch, getState) => {
    dispatch(requestChatAnAdvisor());
    const chatState = getState().chat;
    const isAvailable = chatState.config.available === "Y" && chatState.config.advisorAvailable && !chatState.config.outOfHours;

    if (isAvailable) {
      dispatch(receiveChatAnAdvisor());
    } else {
      dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
    }
  };
}
export function initiateChat(apiClient) {
  return async (dispatch, getState) => {
    dispatch(resetQueueJoinMessage());

    if (apiClient.chatConfig.isSalesforceCaseRequired) {
      await dispatch(initiateAdvisorChat(apiClient));
    } else {
      dispatch(checkIfAdvisorIsAvailable());
    }

    const {
      state,
      dfLocalSession,
      dfCaseId
    } = getState().chat.chatBot;

    if (state === CHAT_STATUS.CALL_CENTER_CLOSED || apiClient.chatConfig.isSalesforceCaseRequired && !dfCaseId) {
      return dispatch(goToErrorScreen());
    }

    if (state !== CHAT_STATUS.ADVISOR_BUSY) {
      try {
        await dispatch(fetchCreateSession(apiClient));
        await dispatch(fetchInitChasitor(apiClient));
        await dispatch(getAdvisorMessage({
          chatId: getState().chat.chatBot.dfId,
          ack: -1,
          local: dfLocalSession,
          apiClient
        }));
      } catch (e) {
        throw new Error(e);
      } finally {
        setTimeout(() => {
          dispatch(timedQueueJoinMessage());
        }, 20000);
      }
    }
  };
}